import { render } from "./Complaint.vue?vue&type=template&id=7a4522bf&scoped=true"
import script from "./Complaint.vue?vue&type=script&lang=js"
export * from "./Complaint.vue?vue&type=script&lang=js"

import "./Complaint.vue?vue&type=style&index=0&id=7a4522bf&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-7a4522bf"

export default script